import React, { useState } from 'react';

import { Box, Flex, Heading, Icon } from '@chakra-ui/react';
import AnimateHeight from 'react-animate-height';

import Panel from '@inspire/ui/general/Panel';
import { FaMinus, FaPlus } from 'react-icons/fa';

const FAQItem = ({ item, ...props }) => {
  const [open, setOpen] = useState(false);
  return (
    <Flex as={Panel} p={0} flexDir="column" {...props}>
      <Flex
        onClick={() => setOpen((x) => !x)}
        cursor="pointer"
        justifyContent="space-between"
        alignItems="center"
        transition="color 0.3s ease"
        color={open ? 'yellow.500' : 'black'}
        px={6}
        py={2}
      >
        <Heading size="sm">{item.question}</Heading>
        <Flex
          transform={open ? 'rotate(0)' : 'rotate(-180deg)'}
          transition="ease-in-out 0.3s"
        >
          <Icon
            as={open ? FaMinus : FaPlus}
            color={open ? 'yellow.500' : 'black'}
          />
        </Flex>
      </Flex>
      <AnimateHeight duration={300} height={open ? 'auto' : 0}>
        <Box
          dangerouslySetInnerHTML={{ __html: item.answer }}
          px={6}
          py={2}
          borderTop="1px solid rgba(0, 0, 0, 0.1)"
          fontSize="sm"
        ></Box>
      </AnimateHeight>
    </Flex>
  );
};

export default FAQItem;
